export enum ContractorStatus {
    ACTIVE = 'ACTIVE',
    INACTIVE = 'INACTIVE',
    POTENTIAL = 'POTENTIAL',
    BLACKLIST = 'BLACKLIST',
}

export interface ContractorAddress {
    street: string;
    city: string;
    postalCode: string;
    country: string;
}

export interface ContractorContact {
    id: string;
    firstName: string;
    lastName: string;
    email: string;
    phone: string;
    role: string;
    isPrimary: boolean;
    contractorId: string;
}

export interface ContractorPrice {
    id: string;
    sku: string;
    asp: number;
    validFrom: string;
    validTo?: string;
    contractorId: string;
}

export interface Contractor {
    id: string;
    name: string;
    nip?: string;
    emails: string[];
    phones: string[];
    description?: string;
    website?: string;
    status: ContractorStatus;
    accountManagerId?: string;
    accountManager?: {
        id: string;
        firstName: string;
        lastName: string;
        email: string;
    };
    contacts: ContractorContact[];
    prices: ContractorPrice[];
    tags: string[];
    invoiceAddress?: ContractorAddress;
    deliveryAddress?: ContractorAddress;
    paymentTerms?: string;
    fulfillmentNotes?: string;
    lastOrderDate?: string;
    discount?: number;
    moq?: number;
    createdAt: string;
    updatedAt: string;
    createdById?: string;
    createdBy?: {
        id: string;
        firstName: string;
        lastName: string;
    };
}

export interface CreateContractorDto {
    name: string;
    nip?: string;
    emails?: string[];
    phones?: string[];
    status?: ContractorStatus;
    accountManagerId?: string;
    tags?: string[];
    invoiceAddress?: ContractorAddress;
    deliveryAddress?: ContractorAddress;
    paymentTerms?: string;
    fulfillmentNotes?: string;
    description?: string;
    website?: string;
    discount?: number;
    moq?: number;
    primaryContact?: Partial<ContractorContact>;
}

export interface UpdateContractorDto extends Partial<CreateContractorDto> { }

export interface ContractorFilters {
    status?: ContractorStatus;
    accountManagerId?: string;
    search?: string;
    page?: number;
    limit?: number;
}

export interface ContractorsResponse {
    data: Contractor[];
    total: number;
}
